<div class="modal-header rn-header">
  <div class="rn-header-content">
    <em class="fas fa-clipboard-list rn-header-icon"></em>
    <h4 class="modal-title mb-0" translate>lblReleaseNote</h4>
  </div>
  <button type="button" class="close" (click)="OnClose()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body rn-body">

  <div class="rn-section" *ngIf="releaseNote">
    <div class="rn-section-header">
      <em class="fas fa-globe-americas mr-2"></em>
      <span translate>lblReleaseNote</span>
    </div>
    <div [innerHTML]="releaseNote | workItemLink" class="rn-content"></div>
  </div>

  <div class="rn-divider" *ngIf="releaseNote && internalReleaseNote && isSuperUser"></div>

  <div class="rn-section rn-section-internal" *ngIf="internalReleaseNote && isSuperUser">
    <div class="rn-section-header">
      <em class="fas fa-lock mr-2"></em>
      <span translate>lblInternalReleaseNote</span>
    </div>
    <div [innerHTML]="internalReleaseNote | workItemLink:'internal'" class="rn-content"></div>
  </div>

</div>

<div class="modal-footer rn-footer">
  <button (click)="OnClose()" class="btn btn-secondary" translate>
    <em class="far fa-times-circle mr-1"></em>lblClose
  </button>
</div>
